import { render } from "./ScoreSelector.vue?vue&type=template&id=281a0703&scoped=true"
import script from "./ScoreSelector.vue?vue&type=script&lang=js"
export * from "./ScoreSelector.vue?vue&type=script&lang=js"

import "./ScoreSelector.vue?vue&type=style&index=0&id=281a0703&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-281a0703"]])

export default __exports__